import { Suspense, useEffect } from 'react';

import ReassignVehiclesTable from '@/features/workshop-assignment/ReassignVehiclesTable';
import { isAssetTreeSelected } from '@/utils/commonUtils';
import { LoadingIndicator } from './LoadingIndicator';
import { REQUEST_ASSET_TREE_SELECTION, sendMessage } from './MessageHandler';

const MainComponent = () => {
    useEffect(() => {
        if (isAssetTreeSelected()) {
            sendMessage({
                type: REQUEST_ASSET_TREE_SELECTION,
                payload: {},
            });
        }
    }, []);

    return (
        <div className={'overflow-hidden display-flex flex-column padding-20 bg-white'}>
            <Suspense fallback={<LoadingIndicator />}>
                <ReassignVehiclesTable />
            </Suspense>
        </div>
    );
};

export default MainComponent;
